import axios from 'axios';
import CONFIG from '../config';

/** Send `language` with each payload (e.g. "French", "Dutch") — required by API. */
const authHeaders = { Authorization: `Bearer ${CONFIG.API_TOKEN}` };

export const submitPdfRangeHints = (payload) => axios.post(
  `${CONFIG.API_BASE}/pdf-range-ev2/hints`,
  payload,
  { headers: authHeaders },
).then((response) => response.data);

export const submitPdfRangeTestDrive = (payload) => axios.post(
  `${CONFIG.API_BASE}/pdf-range-ev2/test-drive`,
  payload,
  { headers: authHeaders },
).then((response) => response.data);

export const submitPdfRangeCodeSubmission = (payload) => axios.post(
  `${CONFIG.API_BASE}/pdf-range-ev2/code-submission`,
  payload,
  { headers: authHeaders },
).then((response) => response.data);
